import { Component, Input } from "@angular/core";
import { OffersComponent } from "../offers/offers.component";

@Component({
    selector: 'tyt-offers-wizard-host',
    templateUrl: './offer-wizard-host.component.html',
    styleUrls: [ './offer-wizard-host.component.scss' ]
})
export class OffersWizardHostComponent {
    constructor (
        readonly offers : OffersComponent
    ) {

    }

    @Input() theme : string;
}